function deferFilterjQuery() {
    if (window.jQuery) {
        var $ = window.jQuery;
        $(function(){
          // On load/reload
          var pt_on_load = function() {
            // Accordion
            

            // Search
            $('.pt-display-search').not('.has_group_selected').find('input.fm-search-box').show();

            // Drop downs on mobile only
            function checkWindowWidth() {
              if ($(window).width() < 1024) {
                $('.filter-group').addClass('pt-display-dropdown');
                
                $('.pt-display-dropdown').each(function( index ) {
                    $(this).find('h4').after($(this).find('.filter-clear'));
                });
    
                $('.pt-display-dropdown .scroll-content').each(function( index ) {
                  if($(this).parent().find('.menu-trigger').length === 0) {
                    if($(this).find('li.selected').length) {
                      var selected = $.map(
                        $(this).find('li.selected a'),
                          function(element){
                            return $(element).text();
                          }
                      ).join(", ");

                      if (selected.length < 30) {
                        $(this).before('<div class="menu-trigger">' + selected +'</div>');
                      } else {
                        $(this).before('<div class="menu-trigger">' + $(this).find('li.selected').length + ' Selected </div>');
                      }
                    }
                    else {
                      $(this).before('<div class="menu-trigger">'+ $(this).closest('.filter-group').find('h4').text() +'</div>');
                    }
                  }
                });
              } else {
                $('.filter-group').removeClass('pt-display-dropdown');
                $('.filter-group .menu-trigger').remove();
                $('.scroll-content').attr('style', '');
              }
            }
            checkWindowWidth();
            $(window).resize(checkWindowWidth);

            //Sticky Mode
            

            // View more
            

            $('.filter-menu li a').attr('title', function() {
              return ($(this).closest('li').hasClass('selected') ? "Clear filter: " : "Add filter: ") + $(this).text();
            });

            // Handle nested filters
            var splitPath = function(url) {
              var splitUrl =  url.split('?')[0].split('#')[0].split('/');
              return splitUrl;
            }

            var getCollection = function(url) {
              var splitUrl = splitPath(url);
              return splitUrl[2];
            }

            var getTags = function(url) {
              var splitUrl = splitPath(url);
              return (splitUrl[3] || '').split('+');
            }

            var getCommonCollection = function(url_top, url_nested) {
              var collection_top = getCollection(url_top);
              var collection_nested = getCollection(url_nested);
              if (collection_top !== collection_nested) {
                return 'all';
              }
              return collection_top;
            }

            var getCommonTags = function(url_top, url_nested) {
              var tags_top = getTags(url_top);
              var tags_nested = getTags(url_nested);

              return tags_top.filter(function(n) {
                return tags_nested.indexOf(n) > -1;
              });
            }

            var getCommonUrl = function(url_top, url_nested) {
              var val = '/collections/' + getCommonCollection(url_top, url_nested) + '/' + getCommonTags(url_top, url_nested).join('+');

              var lastChar = val.slice(-1);
                    if (lastChar == '/') {
                    val = val.slice(0, -1);
                }

              return val;
            }

            var clearNestedParent = $('.pt-display-nested').prev().each(function() {
              var clearNested = $(this).next().find('a.filter-clear').attr('href');
              if (!clearNested) return;
              var clearLink = $(this).find('a.filter-clear');
              clearLink.attr('href', getCommonUrl(clearLink.attr('href'), clearNested))
              var filterLinks = $(this).find('li.selected .collection-name a').each(function() {
                $(this).attr('href', getCommonUrl($(this).attr('href'), clearNested))
              })
            })
          }

          var initSlider = function() {
            if($(".product__grid-item.has_image_slider").length > 0 ){
              if ($(window).width() <= 798){
                if ($(".product__grid-item.has_image_slider").find('.luxury_image_slider').hasClass('flickity-enabled')){
                  $(".product__grid-item.has_image_slider").find('.luxury_image_slider').flickity('destroy');
                }
                $('.product__grid-item.has_image_slider').find('.luxury_image_slider').flickity({
                  prevNextButtons: false,
                  draggable: false,
                  imagesLoaded: true,
                  pageDots: true,
                  on: {
                     ready: function () {
                         if ($(this)[0].slides.length <= 4) {
                             $(this)[0].$element.find('.dot').addClass("show-me");
                         } else {
                             $(this)[0].$element.find('.dot').eq(0).addClass("show-me");
                             $(this)[0].$element.find('.dot').eq(1).addClass("show-me");
                             $(this)[0].$element.find('.dot').eq(2).addClass("show-me");
                             $(this)[0].$element.find('.dot').eq(3).addClass("show-me");
                         }
                    },
                     change: function (index) {
                        if ($(this)[0].slides.length <= 4) {
                            $(this)[0].$element.find('.dot').addClass("show-me");
                        } else {
                            $(this)[0].$element.find('.dot').removeClass("show-me");
                            if (index == 0) {
                                $(this)[0].$element.find('.dot').slice(0, 4).addClass("show-me");
                            } else {
                                if (index == ($(this)[0].slides.length - 1)) {
                                    $(this)[0].$element.find('.dot').eq(index).addClass("show-me");
                                    $(this)[0].$element.find('.dot').eq(index - 1).addClass("show-me");
                                    $(this)[0].$element.find('.dot').eq(index - 2).addClass("show-me");
                                    $(this)[0].$element.find('.dot').eq(index - 3).addClass("show-me");
                                }
                                else {
                                    $(this)[0].$element.find('.dot').eq(index).addClass("show-me");
                                    $(this)[0].$element.find('.dot').eq(index - 1).addClass("show-me");
                                    $(this)[0].$element.find('.dot').eq(index + 1).addClass("show-me");
                                    $(this)[0].$element.find('.dot').eq(index + 2).addClass("show-me");
                                }
                             }
                        }
                    }
                },
                initialIndex: 0
                })
              } else {
                if ($(".product__grid-item.has_image_slider").find('.luxury_image_slider').hasClass('flickity-enabled')){
                  $(".product__grid-item.has_image_slider").find('.luxury_image_slider').flickity('destroy');
                }
              }
            }
          }

          pt_on_load();

          // Mobile filter button
          
          $(document).on('click', '.filter-menu .pt-mobile-header a.pt-nav-toggle', function(e){
            $('.filter-group-sort-orders.desk-hidden').removeClass('pt-expand');
            $('.filter-menu .pt-mobile-header a.pt-src-toggle').removeClass('active');
              
            if(e.handled !== true) {
              if ($(this).hasClass('active')) {
                $('.filter-menu').removeClass('pt-expand');
                $('.pt-display-dropdown .scroll-content').hide();
              } else {
                $('.filter-menu').addClass('pt-expand');
              }

              $(this).toggleClass('active');
              e.preventDefault();
              e.handled = true;
            }
          });
          $(document).on('click', '.filter-menu .pt-mobile-header a.pt-src-toggle', function(e){
            $('.filter-menu').removeClass('pt-expand');
            $('.pt-display-dropdown .scroll-content').hide();
            $('.filter-menu .pt-mobile-header a.pt-nav-toggle').removeClass('active');
            
            if(e.handled !== true) {
              if ($(this).hasClass('active')) {
                $('.filter-group-sort-orders.desk-hidden').removeClass('pt-expand');
                $('.filter-group-sort-orders.desk-hidden .scroll-content').hide();
              } else {
                $('.filter-group-sort-orders.desk-hidden').addClass('pt-expand');
                $('.filter-group-sort-orders.desk-hidden .scroll-content').show();
              }

              $(this).toggleClass('active');
              e.preventDefault();
              e.handled = true;
            }
          });

          

          // Accordion
          

          // Search
          $(document).on('keyup', '.filter-group input.fm-search-box', function () {
            var value = this.value.toLowerCase();
            $(this).closest('.filter-group').find('li').each(function () {
              if ($(this).text().toLowerCase().search(value) > -1) {
                $(this).show(100);
              } else {
                $(this).hide(100);
              }
            });
          });

          // Drop downs
          $(document).on('click','.pt-display-dropdown .menu-trigger',function() {
            $(this).next('.scroll-content').css('top', $(this).position().top + $(this).height() + 1).css('left', $(this).position().left);
            $(this).next('.scroll-content').slideToggle('fast');
          });

          $(document).on('mouseleave', '.pt-display-dropdown .scroll-content', function() {
            $(this).slideUp('fast');
          });

          // Apply button
          
          $('body').on('click', '.filter-group li.collection-container a, .filter-group a.filter-clear, .filter-group-sort-orders .collection-name a, .pagination li a', function(e) {
            e.preventDefault();
            var current_url = $(this).attr('href');
            $('.filter-menu').data('current-url', current_url).fadeTo('slow', 0.8);
            $.get(current_url, function( data ) {
              var elem = $(data).find('.filter-menu').first();
              var collectionData = $(data).find('[data-collection-main]').first();
              $('.filter-menu').replaceWith(elem).fadeTo('fast', 1.0);
               $('[data-collection-main]').replaceWith(collectionData).fadeTo('fast', 1.0);
              
              pt_on_load();
              initSlider();
              // $('.filter-menu .pt-mobile-header a').trigger('click');
              window.history.replaceState(null, null, current_url);
              var parts = current_url.split('=');
              var firstPart = parts[0];
               if (firstPart === '/collections/shop?q') {
                  location.reload();
              }
              else
               {
                 window.scrollTo(0, 0);
               }
            });
          });

          // Ajax
          
          $.getScript("//www.safeandvaultstore.com/cdn/shop/t/225/assets/jquery.pjax.js?v=138580039773092267901781786672").done(function(script, textStatus) {
            $body = $("body");
            $(document).pjax('.collection_sec_wrapper .filter-group a, .collection_sec_wrapper .pagination a', '.collection_sec_wrapper', { fragment: '.collection_sec_wrapper', timeout: 10000, scrollTo: false, push: true });
            $(document).on('pjax:start', function(){  $body.addClass("pt-ajax-loading"); $('.collection_sec_wrapper').fadeTo('slow', 0.8); })
            $(document).on('pjax:end', function(){ $body.removeClass("pt-ajax-loading"); $('.collection_sec_wrapper').fadeTo('fast', 1); pt_on_load(); ; });
          });
          
      });
    }
    else {
        setTimeout(function() { deferFilterjQuery() }, 50);
    }
}

deferFilterjQuery();
